import {
  createConfig,
  getConfigByTypeKey,
  deleteConfig,
  updateConfig,
} from "./configurationService";
import { getUserName } from "./auth";

let _type = null;
const getType = async () => {
  if (!_type) {
    const userName = await getUserName();
    _type = `preferences--${userName}`;
  }
  return _type;
};

const scope = ["owner"];
const PREFERENCES_KEY = "user_notification_preferences";

const defaultPreferences = {
  email: false,
  text: false,
  phone_number: null,
};

export const preferencesService = {
  getUserPreferences: async () => {
    try {
      const type = await getType();
      const cfg = await getConfigByTypeKey(type, PREFERENCES_KEY);
      if (cfg && cfg.value) {
        const parsedValue = JSON.parse(cfg.value);
        return parsedValue.value || defaultPreferences;
      }
      throw new Error("Preferences not found or invalid");
    } catch (error) {
      console.error("Error fetching user preferences:", error);
      await preferencesService.updateUserPreferences(defaultPreferences);
      return defaultPreferences;
    }
  },

  updateUserPreferences: async (preferences) => {
    const type_ = await getType();
    const saveObj = JSON.stringify({ value: preferences });
    try {
      const obj = await getConfigByTypeKey(type_, PREFERENCES_KEY);
      if (!obj || !obj.id) {
        return await createConfig(
          type_,
          PREFERENCES_KEY,
          saveObj,
          null,
          null,
          scope,
          scope,
          scope
        );
      } else {
        return await updateConfig(obj.id, type_, PREFERENCES_KEY, saveObj);
      }
    } catch (error) {
      console.error("Error updating user preferences:", error);
      return await createConfig(
        type_,
        PREFERENCES_KEY,
        saveObj,
        null,
        null,
        scope,
        scope,
        scope
      );
    }
  },

  get: async (key, defaultValue = null) => {
    try {
      const cfg = await getConfigByTypeKey(await getType(), key);
      return JSON.parse(cfg.value).value ?? defaultValue;
    } catch (_) {
      return defaultValue;
    }
  },

  set: async (name, value) => {
    const obj = await getConfigByTypeKey(await getType(), name);
    const type_ = await getType();
    const saveObj = JSON.stringify({ value: value });
    if (!obj || !obj.id) {
      return await createConfig(
        type_,
        name,
        saveObj,
        null,
        null,
        scope,
        scope,
        scope
      );
    } else {
      return await updateConfig(obj.id, type_, name, saveObj);
    }
  },

  delete: async (name) => {
    const obj = await preferencesService.get(name);
    if (!obj || !obj.id) {
      return null;
    }
    return await deleteConfig(obj.id);
  },
};

export default preferencesService;